import { createSelector } from 'reselect';
import { getMachineOperationalStatus } from './getMachineOperationalStatus';
import { getWaitingForWorkEnabled } from './getWaitingForWorkEnabled';

export const getIsUnknownJob = createSelector(
  [getMachineOperationalStatus, getWaitingForWorkEnabled],
  (machineOperationalStatus, waitingForWorkEnabled) => {
    return (
      waitingForWorkEnabled &&
      machineOperationalStatus?.status === 'unknown_job'
    );
  }
);
